import myLogo from './AuctionSnap.png'
import eventLogo from './eventsnap-logo-outline.png'
import './logo.css'

export const Logo = ({ ...props }) => {
  return <div className="image-container">
    <img src={eventLogo} {...props} alt="Auction Snap Admin Logo" />
  </div>
}
